/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../logger';
import { BidRequestObject, PrebidFormattedKeyValues } from '../types/prebid';
import { deepMerge } from '../util';

const logger = Logger.getInstance();

class IndexExchange {
  static bidderName = 'ix';

  static updateBidRequest(
    bidRequest: BidRequestObject,
    targetingData: PrebidFormattedKeyValues
  ): void {
    const allValues: string[] = Object.values(targetingData).flatMap((adUnit) =>
      Object.values(adUnit)
    );
    const hasComma = allValues.some((value) => value.includes(','));

    const processedValues = hasComma
      ? allValues.flatMap((value) => value.split(',').map((v) => v.trim()))
      : allValues;

    const uniqueValues: string[] = Array.from(new Set(processedValues));

    if (uniqueValues.length > 0) {
      logger.info(
        `Adding Index Exchange nodals targeting data to bid request: ${uniqueValues.join(', ')}`
      );
      bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName] =
        bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName] || {};
      deepMerge(bidRequest.ortb2Fragments.bidder[IndexExchange.bidderName], {
        user: {
          ext: {
            data: {
              nodals: uniqueValues,
            },
          },
        },
      });
    }
  }
}

export default IndexExchange;
